<template>
    <not-found-view v-if="error" :error500="true"></not-found-view>

    <div v-else class="grid grid--padding">
        <div v-if="!$apollo.loading" class="game-options">
            <progress-bar :total="totalStepCount" :current="currentStep"></progress-bar>

            <div v-if="showSteps" class="game-options__wrapper">
                <h2 class="game-options__title">{{ currentStepData.name }}</h2>
                <p class="game-options__desc">{{ currentStepData.description }}</p>

                <div class="game-options__container">
                    <number-input v-if="isNumberType" :options="currentStepData"></number-input>
                    <option-items v-else :options="currentStepData.gameOptions" :regions="regions" :nextStep="nextStep"></option-items>
                </div>
            </div>

            <div class="game-options__wrapper">
                <button v-if="isNumberType" @click="nextStep" :id="currentStepData.gameOptions[0].uniqueId" class="btn btn--primary">
                    {{ $t('button.next') }}
                </button>
                <router-link v-if="currentStep == 1" :to="{name: 'home'}" class="btn">
                    {{ $t('button.cancel') }}
                </router-link>
                <button v-if="currentStep != 1 && showSteps" @click="previousStep" class="btn">
                    {{ $t('button.back') }}
                </button>
            </div>
        </div>

        <overview-layout v-if="!showSteps" :items="savedOptions" :horizontal="true">
            <template #header>
                <h2 class="game-options__title">{{ $t('game-options.overview.title') }}</h2>
            </template>

            <template #footer>
                <h3 class="game-options__title">{{ $t('game-options.overview.text') }}</h3>
                <router-link :to="{name: 'game'}" class="btn btn--primary">
                    {{ $t('button.start-building') }}
                </router-link>
                <button @click="resetOptions" class="btn btn--secondary">
                    {{ $t('button.change-all') }}
                </button>
            </template>
        </overview-layout>
    </div>
</template>

<script>
import { getGameOptionRegionListing, getGameOptionStepListing } from '@/queries/gameOptionsQueries.js';
import ProgressBar from '@/components/game/ProgressBar.vue';
import NumberInput from '@/components/game/NumberInput.vue';
import OptionItems from '@/components/game/OptionItem.vue';
import OverviewLayout from '@/components/game/OverviewLayout.vue';

export default {
    name: 'GameOptionsView',
    components: {
        ProgressBar,
        NumberInput,
        OptionItems,
        OverviewLayout
    },
    data() {
        return {
            error: false,
            getGameOptionRegionListing: null,
            getGameOptionStepListing: null,
        }
    },
    apollo: {
        getGameOptionRegionListing: {
            query: getGameOptionRegionListing,
            error(error) {
                console.log('errors', error);
                this.error = true;
            }
        },
        getGameOptionStepListing: {
            query: getGameOptionStepListing,
            error(error) {
                console.log('errors', error);
                this.error = true;
            }
        }
    },
    computed: {
        regions() {
            return this.getGameOptionRegionListing.edges;
        },
        currentStep() {
            return this.$store.getters['game/getCurrentStep'];
        },
        totalStepCount() {
            return this.getGameOptionStepListing ? this.getGameOptionStepListing.totalCount + 1 : 2;
        },
        showSteps() {
            if (this.currentStep < this.totalStepCount) {
                return true;
            } else {
                return false;
            }
        },
        currentStepData() {
            if (this.showSteps) {
                return this.getGameOptionStepListing.edges[this.currentStep - 1].node;
            } else {
                return false;
            }
        },
        isNumberType() {
            if (this.showSteps && this.currentStepData.gameOptions[0].maxValue) {
                return true;
            } else {
                return false;
            }
        },
        savedOptions() {
            return this.$store.getters['game/getSavedOptions'];
        }
    },
    methods: {
        nextStep(event) {
            this.saveCurrentStepOption(event.target.id);

            if (this.$store.getters['game/getIsUpadtingOption']) {
                this.$store.commit('game/updateStep', this.totalStepCount);
                this.$store.commit('game/updatingOption', false);
            } else {
                let nextStep = this.currentStep + 1;
                this.$store.commit('game/updateStep', nextStep);
            }
        },
        previousStep() {
            let prevStep = this.currentStep - 1;
            this.$store.commit('game/updateStep', prevStep);
        },
        saveCurrentStepOption(id) {
            let option = {
                id: this.currentStepData.id,
                key: this.currentStepData.key,
                icon: this.currentStepData.icon,
                data: null,
            }

            if (this.isNumberType) {
                option.data = {
                    value: document.querySelector('.input--number').textContent
                };
            } else if (this.currentStepData.gameOptions[0].region) {
                let gameOption = this.regions.filter(region => region.node.id == id);
                option.data = {
                    value: gameOption[0].node.name,
                    uniqueId: gameOption[0].node.id
                };
            } else {
                let gameOption = this.currentStepData.gameOptions.filter(option => option.uniqueId == id);
                option.data = {
                    value: gameOption[0].quantity.value,
                    valueFormatted: gameOption[0].quantity.toString,
                    unit: gameOption[0].quantity.unit,
                    uniqueId: gameOption[0].uniqueId,
                    garden: gameOption[0].garden,
                    hipRoof: gameOption[0].hipRoof,
                    windowQuantity: gameOption[0].windowQuantity
                };
            }

            this.$store.commit('game/saveOption', option);
        },
        resetOptions() {
            this.$store.dispatch('game/resetGameOptions');
        }
    }
}
</script>
